import TEMPLATE_URL from "webmodals/parser/parser-prompt.htm";
import controller from "webmodals/parser/parser-prompt.controller";
import modals from "webmodals/modals";

export default ({
  size = "md",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  defaultValue = "",
  rows = 8,
  tokens = defaultValue,
  delimiter = /[\s,]+/gi,
  title = "Token parser...",
  label = "Tokens",
  subTitle = "Enter tokens separated by comma or white-space",
} = {}) =>
  modals.open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        title,
        subTitle,
        label,
        rows,
        tokens,
        delimiter,
      }),
    },
  }).result;
